import React from "react";
import CustomScrollbars from "util/CustomScrollbars";
import SidebarLogo from "./SidebarLogo";
import {
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
} from "../../constants/ThemeSetting";
import { useSelector } from "react-redux";
import { MainMenu } from "../../app/components/Menu/MainMenu";

const SidebarContent = ({ sidebarCollapsed, setSidebarCollapsed }) => {
  const { navStyle } = useSelector(({ settings }) => settings);
  const getNoHeaderClass = (navStyle) => {
    if (
      navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR ||
      navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR
    ) {
      return "gx-no-header-notifications";
    }
    return "";
  };

  return (
    <>
      <SidebarLogo
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
      />
      <div className="gx-sidebar-content base-color">
        <div
          className={`gx-sidebar-notifications ${getNoHeaderClass(navStyle)}`}
        >

        </div>
        <CustomScrollbars className="gx-layout-sider-scrollbar">
          {<MainMenu />}
        </CustomScrollbars>
      </div>
    </>
  );
};

export default React.memo(SidebarContent);
